import Typography from "@mui/material/Typography";

export const PageTitle: React.FC<{ title: string }> = ({ title }) => {
  return (
      <Typography
        sx={{ mt: 4, mb: 2, mr: 4, ml: 2, fontWeight: "bold" }}
        variant="h4"
        component="div"
      >
        {title}
      </Typography>
  );
}

export const SectionTitle: React.FC<{ title: string }> = ({ title }) => {
  return (
      <Typography
        sx={{ mb: 1, fontWeight: "bold" }}
        variant="h5"
        component="div"
      >
        {title}
      </Typography>
  );
}